t = require('app/scripts/views/internal/teacup-with-helpers')('card_menu_meta')

module.exports = ->
  t.hr()

  t.div ->

    t.div ->
      t.label ->
        t.format 'link-to-this-card'
        t.text ' '
        t.icon t.mustacheVar('pLevelClass'), { title: t.mustacheVar('pLevelAltText') }
      t.input '.js-short-url.js-autofocus', { type: 'text', readonly: 'readonly', value: t.mustacheVar('shortUrl') }

    t.div ->
      t.label ->
        t.format 'embed-this-card'
      t.input '.js-embed', { type: 'text', readonly: 'readonly', value: t.mustacheVar('embed') }

    t.mustacheBlock 'email', ->
      t.mustacheBlock '__ed', ->
        t.div ->
          t.label ->
            t.format 'email-for-this-card'
          t.input '.js-email', { type: 'text', readonly: 'readonly', value: t.mustacheVar('email') }
          t.p '.quiet', { stlye: "margin: 0 4px;" }, ->
            t.l('emails-sent-to-this-address-will-appear-as-a-comment-by-you-on-the-card')

    t.hr()

    t.div '.quiet', ->
      # guide/hacks/id-short
      t.mustacheBlock 'idShort', ->
        t.p { style: 'display: inline-block; margin: 0 8px 0 0;' }, ->
          t.format 'card-idshort', { idShort: t.mustacheVar('idShort') }
          t.text ' '

      t.p { style: 'display: inline-block; margin: 0;' }, ->
        t.mustacheBlock 'dateAdded', ->
          t.format 'added', { dateAdded: t.mustacheVar('dateAdded') }

        t.mustacheBlock '__ed', ->
          t.text ' - '
          t.a '.js-delete', { href: '#' }, ->
            t.format 'delete'
